export class ViewApplicationLocationTpamsConstants {
    static STEP_TITLE = "Location";
    static ZONE_LABEL = "Current property zoning";
    static OWNER_LABEL = "Owners";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static BUILDING_USE_CONTROL = "buildingUse";
    static ERF_SIZE_CONTROL = "erfSize";
    static BUILDING_FLOOR_AREA_CONTROL = "buildingFloorArea";
    static TITLE_DEED_CONTROL = "titleDeed";
    static ZONE_CONTROL = "zones";
    static OWNER_CONTROL = "owners";
    static PROPERTIES_CONTROL = "properties";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static BUILDING_USE_TEXT_PLACEHOLDER = "Building use";
    static ERF_SIZE_TEXT_PLACEHOLDER = "Erf size";
    static BUILDING_FLOOR_AREA_TEXT_PLACEHOLDER = "Building floor area";
    static TITLE_DEED_TEXT_PLACEHOLDER = "Title deed";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static LAYER_REF = "Town planning graphics";
}
